import { EditBasicDetailsFormData } from "./config";
import { BasicDetailsData } from "./types";

export function getUpdatePayload(
  data: EditBasicDetailsFormData
): Record<string, string | undefined> {
  return {
    industry: data.industry || undefined,
    title: data.title || undefined,
    description: data.description || undefined,
    no_of_emp: data.no_of_emp || undefined,
  };
}

export function mapDataToFormValues(
  data: BasicDetailsData | null
): EditBasicDetailsFormData {
  if (!data) {
    return {
      industry: "",
      title: "",
      description: "",
      no_of_emp: "",
    };
  }
  return {
    industry: data.industry ?? "",
    title: data.title ?? "",
    description: data.description ?? "",
    no_of_emp: data.no_of_emp ?? "",
  };
}
